import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, ComponentFactoryResolver, HostListener, ViewChild, ViewContainerRef } from '@angular/core';
import { AlertController, Events, ModalController, ToastController } from 'ionic-angular';
import { ModalPopupPage } from '../../pages/modal-popup/modal-popup';
import { CommunicationServiceProvider } from '../../providers/communication-service/communication-service';
import { ComponentServiceProvider } from '../../providers/component-service/component-service';
import { ConfigApiServiceProvider } from '../../providers/config-api-service/config-api-service';
import { DataServiceProvider } from '../../providers/data-service/data-service';
import { ExportServiceProvider } from '../../providers/export-service/export-service';
import { PriceListTableProvider } from '../../providers/price-list-table/price-list-table';

declare var jQuery;
const DEFAULTVALUE = 0;
@Component({
  selector: 'component-holder',
  templateUrl: 'component-holder.html'
})
export class ComponentHolderComponent {
  inputData: any = 'All';
  showList: boolean = false;
  showSideMenu: boolean = true;
  pageClassName: any;
  componentRef: any;
  showSideBar: boolean = false;
  selTemplates: any = [];
  broadcastSubs: any;
  @ViewChild('container', {
    read: ViewContainerRef,
  }) viewContainerRef: ViewContainerRef;
  constructor(private alertCtrl: AlertController,public communicationServ: CommunicationServiceProvider, public configApiService: ConfigApiServiceProvider,public toastController: ToastController, public priceListTableService: PriceListTableProvider,public datePipe: DatePipe,public exportService : ExportServiceProvider,public dataService: DataServiceProvider, private cdr: ChangeDetectorRef, private resolver: ComponentFactoryResolver, public modalCtrl: ModalController, public events: Events, public componentService: ComponentServiceProvider) {
  }
  ngOnInit(){
    this.initCalculation();
  }
  initCalculation(){
    this.broadcastSubs = this.communicationServ.getInstance()
    .subscribe((data: any) => {
      if(data.src ===  'proposal-create'){
        if(data.event === 'SCREEN_CALCULATION'){
          let flag = data['status'];
          if(flag){
            this.reCalculation();
          }
        }
      }
    });
  }
  reCalculation(){
    var priceListData = JSON.parse(localStorage.getItem('Pricelist'));
    if (priceListData != null) {
    this.priceListTableService.priceList = priceListData;
    }
  this.priceListTableService.pricelistCalculation();
  this.dataService.ProposalTable.mspForm.dashboard.forEach(element => {
    if(element.published == false && element.name == 'MSP'){
      this.MspScreenActivity();
    }else if(element.published == false && element.name == 'PJT'){
      this.ProjectActivity();
    }else if(element.published == false && element.name == 'BKP'){
      this.BackupDrScreenActivity();
    }else if(element.published == false && element.name == 'CYB'){
      this.CyberScreenActivity();
    }else if(element.published == false && element.name == 'CLD'){
      this.CloudScreenActivity();
    }
  });
  }
  clearAllData(){
    this.dataService.ClearData();
    // this.priceListTableService.ClearData();
    this.componentService.ClearData();
    localStorage.removeItem("ViewScreen");
    this.configApiService.getPriceListMaster();
    this.configApiService.getMsaMaster();
    this.configApiService.getSowMaster();
    this.configApiService.getSowListMaster();
    // let index = this.componentService.tabTemplates.findIndex(item => item.id == 'ProposalViewer')
    // localStorage.setItem('ViewScreen', JSON.stringify(this.componentService.tabTemplates[index].templates));
    this.dataService.ProposalTable.mspForm.startDate = this.datePipe.transform('', 'dd-MMM-yyyy');
    this.dataService.ProposalTable.mspForm.proposalDate = this.datePipe.transform('', 'dd-MMM-yyyy');
    this.dataService.ProposalTable.mspForm.proposedStartDate = this.datePipe.transform('', 'dd-MMM-yyyy');
    this.dataService.ProposalTable.mspForm.msaData.newDate = this.datePipe.transform('', 'dd-MMM-yyyy');
    this.dataService.ProposalTable.mspForm.msaData.existingDate = this.datePipe.transform('', 'dd-MMM-yyyy');
    this.dataService.ProposalTable.mspForm.dashboard.forEach(element => {
      element.overrideDate = this.datePipe.transform('', 'dd-MMM-yyyy');
      });
    setTimeout(() => {
      jQuery(".wc-date-container span").text("");
  }, 10);
  const toast = this.toastController.create({
    message: 'All Data has been Cleared',
    duration: 3000,
  });
  toast.present();
  }
  exportJSON(){
    let obj = {
      "ProposalTable" : this.dataService.ProposalTable,
      "PriceList": this.priceListTableService.priceList,
    }
    const file = new Blob([JSON.stringify(obj)], { type: 'text/json' });
    this.exportService.download(file, "Export.json");
  }
  addNewContract(){
    if (this.dataService.ProposalTable.mspForm.msaData.fileName == '') {
      let obj = {
        "contract_file_1_Id": this.dataService.dashboardContractId != '' ? this.dataService.dashboardContractId : '',
        "Contract_Date": this.dataService.ProposalTable.mspForm.msaData.newDate != null ? this.dataService.ProposalTable.mspForm.msaData.newDate : this.dataService.ProposalTable.mspForm.msaData.existingDate,
        "Client_": this.dataService.ProposalTable.mspForm.ClientCode,
        "Contract_type": 'MSA',
        "Contract_Status": "InProgress",
        "Filename": this.dataService.ProposalTable.mspForm.msaData.fileName,
        "status": "",
        "Tag": "",
        "Created_date": "",
        "Created_By": "",
        "Modified_By": "",
        "Modified_date": "",
        "jsonData": this.dataService.ProposalTable,
        "userid": 3280,
        "rptname": "contract_file_12095",
        "client": "starport1294"
      }
      let objData = { data: JSON.stringify(obj) }
      this.configApiService.saveContract(objData).subscribe(respdata => {
      });
    }
    this.dataService.ProposalTable.mspForm.dashboard.forEach(element => {
      if (element.activate == true) {
        var tab = element.name.toLowerCase() + 'ContractId';
        let obj = {
           "contract_file_1_Id":  this.dataService[tab] != '' ?  this.dataService[tab] : '',
           "Contract_Date": this.dataService.ProposalTable.mspForm.startDate,
           "Client_": this.dataService.ProposalTable.mspForm.ClientCode,
           "Contract_type": element.name,
           "Contract_Status":"InProgress",
           "Filename": element.fileName,
           "status": "",
           "Tag": "",
           "Created_date": "",
           "Created_By": "",
           "Modified_By": "",
           "Modified_date": "",
           "jsonData": this.dataService.ProposalTable,
           "userid": 3280,
           "rptname": "contract_file_12095",
           "client": "starport1294"
       }
       let objData = {data : JSON.stringify(obj)}
       this.configApiService.saveContract(objData).subscribe(respdata =>{
            });
           } 
    });
    this.clearAllData();
    const toast = this.toastController.create({
      message: 'Existing Records has been Saved and Created a New Contract',
      duration: 3000,
    });
    toast.present();
  }
  importJSON(){
    let myModal = this.modalCtrl.create(ModalPopupPage, { 'name': 'Import' });
    myModal.onDidDismiss(data => {
      if(data != null && data.ProposalTable != undefined){
        // localStorage.setItem("SelectedDevices", JSON.stringify(data.ProposalTable.MspDattoIntronis));
        // localStorage.setItem("BackupDrSelectedDevices", JSON.stringify(data.ProposalTable.BackupDrDattoIntronis));
        localStorage.setItem("AllDatto", JSON.stringify(data.ProposalTable.AllDatto));
        localStorage.setItem("AllIntronis", JSON.stringify(data.ProposalTable.AllIntronis));
        localStorage.setItem("BackupDrAllDatto", JSON.stringify(data.ProposalTable.BackupDrAllDatto));
        localStorage.setItem("BackupDrAllIntronis", JSON.stringify(data.ProposalTable.BackupDrAllIntronis));
        localStorage.setItem("MSPForm", JSON.stringify(data.ProposalTable.mspForm));
        localStorage.setItem('MSPScreenData', JSON.stringify(data.ProposalTable.mspPricingSheet));
        localStorage.setItem('CYBERScreenData', JSON.stringify(data.ProposalTable.cyberPricingSheet));
        localStorage.setItem('CLOUDScreenData', JSON.stringify(data.ProposalTable.cloudPricingSheet));
        localStorage.setItem('BACKUPDRsScreenData', JSON.stringify(data.ProposalTable.backupDrPricingSheet));
        localStorage.setItem('HWSWScreenData', JSON.stringify(data.ProposalTable.hwswHaasSaasSheet));
        localStorage.setItem('ProjectScreen', JSON.stringify(data.ProposalTable.projectScreen));
        localStorage.setItem('Pricelist', JSON.stringify(data.PriceList));
        this.priceListTableService.priceList = data.PriceList;
        this.dataService.ProposalTable = data.ProposalTable;
      }
    });
    myModal.present();
  }
  editPage(event) {
      this.dataService.broadcastInfo({ src: 'proposal-edit', event: 'EDIT_PROPOSAL', status: true});
  }
  loadContract(){
    let myModal = this.modalCtrl.create(ModalPopupPage, { 'name': 'LoadContract' });
    myModal.onDidDismiss(data => {
    })
    myModal.present();
  }
  savePage(){
    this.dataService.broadcastInfo({ src: 'proposal-save', event: 'SAVE_PROPOSAL', status: true});
  }
  showMoreList(event) {
    this.showList = true;
  }
  CloudScreenActivity(){
    if (localStorage.getItem('CLOUDScreenData')) {
      let cloudPricingSheet =  JSON.parse(localStorage.getItem('CLOUDScreenData'));
      let setupVal =  (parseFloat(cloudPricingSheet.SetupConfigHours != '' ? cloudPricingSheet.SetupConfigHours : '0') * parseFloat(this.priceListTableService.priceList.TotalLabourRegularRate.slice(1).replace(/  |,/gi,"")));
      if(setupVal != DEFAULTVALUE){
        cloudPricingSheet.SetupConfigOneTime = '$' + setupVal.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      }else{
        cloudPricingSheet.SetupConfigOneTime = '';
      }
      let ttlStartup = (parseFloat(cloudPricingSheet.SetupConfigOneTime != '' ? cloudPricingSheet.SetupConfigOneTime.slice(1).replace(/  |,/gi,"") : '0') - parseFloat(cloudPricingSheet.CourtesyDiscountOneTime != '' ? cloudPricingSheet.CourtesyDiscountOneTime.slice(1).replace(/  |,/gi,"") : '0'));
      if(ttlStartup != DEFAULTVALUE){
        cloudPricingSheet.TotalStartUp = '$' + ttlStartup.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      }else{
        cloudPricingSheet.TotalStartUp = '';
      }
      let mnthRecurring = (parseFloat(cloudPricingSheet.monthlyRecurring.hours != '' ? cloudPricingSheet.monthlyRecurring.hours : '0') * parseFloat(this.priceListTableService.priceList.TotalLabourRegularRate.slice(1).replace(/  |,/gi,"")));
      if(mnthRecurring != DEFAULTVALUE){
        cloudPricingSheet.monthlyRecurring.oneTime = '$' + mnthRecurring.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      }else{
        cloudPricingSheet.monthlyRecurring.oneTime = '';
      }
      cloudPricingSheet.monthlyRecurring.IaaS.forEach(element => {
        if(element.serverName != ''){
          element.base = this.priceListTableService.priceList.CloudServerAndSW.server.SellValue;
        }
        if(element.cpuQty != ''){
          element.cpuPrice = this.priceListTableService.priceList.CloudServerAndSW.cpu.SellValue;
          element.cpuSubTtl = '$' + (parseFloat(element.cpuQty) * parseFloat(element.cpuPrice.slice(1).replace(/  |,/gi,""))).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",").replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        }
        if(element.ramQty != ''){
          element.ramPrice = this.priceListTableService.priceList.CloudServerAndSW.ram.SellValue;
          element.ramSubTtl = '$' + (parseFloat(element.ramQty) * parseFloat(element.ramPrice.slice(1).replace(/  |,/gi,""))).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",").replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        }
        if(element.diskQty != ''){
          element.diskPrice = this.priceListTableService.priceList.CloudServerAndSW.disk.SellValue;
          element.diskSubTtl = '$' + (parseFloat(element.diskQty) * parseFloat(element.diskPrice.slice(1).replace(/  |,/gi,""))).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",").replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        }
        let sumArray = [];
        let baseVal = element.base != '' ? parseFloat(element.base.slice(1).replace(/  |,/gi,"").replace(/  |,/gi,"")) : DEFAULTVALUE;
        let cpuVal = element.cpuSubTtl != '' ? parseFloat(element.cpuSubTtl.slice(1).replace(/  |,/gi,"").replace(/  |,/gi,"")) : DEFAULTVALUE;
        let ramVal = element.ramSubTtl != '' ? parseFloat(element.ramSubTtl.slice(1).replace(/  |,/gi,"").replace(/  |,/gi,"")) : DEFAULTVALUE;
        let diskVal = element.diskSubTtl != '' ? parseFloat(element.diskSubTtl.slice(1).replace(/  |,/gi,"").replace(/  |,/gi,"")) : DEFAULTVALUE;
        sumArray.push(baseVal,cpuVal,ramVal,diskVal);
        var value = sumArray.reduce(function (a, b) {
          return a + b;
        }, 0);
        if(value != DEFAULTVALUE){
          element.Total = '$' + value.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",").replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        }else{
          element.Total = '';
        }
      });
      let baseArray = [];
      cloudPricingSheet.monthlyRecurring.IaaS.forEach(elem => {
        if(elem.base != ''){
          baseArray.push(parseFloat(elem.base.slice(1).replace(/  |,/gi,"").replace(/  |,/gi,"")));
        }
      });
      var value1 = baseArray.reduce(function (a, b) {
        return a + b;
      }, 0);
      if(value1 != DEFAULTVALUE){
        cloudPricingSheet.monthlyRecurring.TotalBase = '$' + value1.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",").replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      }else{
        cloudPricingSheet.monthlyRecurring.TotalBase = '';
      }
      let ramArray = [];
      cloudPricingSheet.monthlyRecurring.IaaS.forEach(elem => {
        if(elem.ramSubTtl != ''){
          ramArray.push(parseFloat(elem.ramSubTtl.slice(1).replace(/  |,/gi,"").replace(/  |,/gi,"")));
        }
      });
      var value2 = ramArray.reduce(function (a, b) {
        return a + b;
      }, 0);
      if(value2 != DEFAULTVALUE){
       cloudPricingSheet.monthlyRecurring.TotalRam = '$' + value2.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",").replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      }else{
        cloudPricingSheet.monthlyRecurring.TotalRam = '';
      }
      let cpuArray = [];
      cloudPricingSheet.monthlyRecurring.IaaS.forEach(elem => {
        if(elem.cpuSubTtl != ''){
          cpuArray.push(parseFloat(elem.cpuSubTtl.slice(1).replace(/  |,/gi,"").replace(/  |,/gi,"")));
        }
      });
      var value3 = cpuArray.reduce(function (a, b) {
        return a + b;
      }, 0);
      if(value3 != DEFAULTVALUE){
       cloudPricingSheet.monthlyRecurring.TotalCpu = '$' + value3.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",").replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      }else{
       cloudPricingSheet.monthlyRecurring.TotalCpu = '';
      }
      let diskArray = [];
     cloudPricingSheet.monthlyRecurring.IaaS.forEach(elem => {
        if(elem.diskSubTtl != ''){
          diskArray.push(parseFloat(elem.diskSubTtl.slice(1).replace(/  |,/gi,"").replace(/  |,/gi,"")));
        }
      });
      var value4 = diskArray.reduce(function (a, b) {
        return a + b;
      }, 0);
      if(value4 != DEFAULTVALUE){
        cloudPricingSheet.monthlyRecurring.TotalDisk = '$' + value4.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",").replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      }else{
       cloudPricingSheet.monthlyRecurring.TotalDisk = '';
      }
      let totalArray = [];
      cloudPricingSheet.monthlyRecurring.IaaS.forEach(elem => {
        if(elem.Total != ''){
          totalArray.push(parseFloat(elem.Total.slice(1).replace(/  |,/gi,"").replace(/  |,/gi,"")));
        }
      });
      var value5 = totalArray.reduce(function (a, b) {
        return a + b;
      }, 0);
      if(value5 != DEFAULTVALUE){
       cloudPricingSheet.monthlyRecurring.SubtotalIaaS = '$' + value5.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",").replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      }else{
        cloudPricingSheet.monthlyRecurring.SubtotalIaaS = '';
      }
      cloudPricingSheet.monthlyRecurring.SaaS.forEach(element => {
        this.priceListTableService.priceList.CloudServerAndSW.SWItem.forEach(elem => {
          if(element.item == elem.item){
            element.price = elem.SellValue;
            if(element.qty != '' && element.price != ''){
              element.total = '$' + (parseFloat(element.qty) * parseFloat(element.price.slice(1).replace(/  |,/gi,""))).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",").replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
            }else{
              element.total = '';
            }
          }
        });
      });
    var subTotal = [];
    cloudPricingSheet.monthlyRecurring.SaaS.forEach(elem=>{
      if(elem.total != ''){
        subTotal.push(parseFloat(elem.total.slice(1).replace(/  |,/gi,"").replace(/  |,/gi,"")));
      }
    });
    var value6 = subTotal.reduce(function (a, b) {
      return a + b;
    }, 0);
    if(value6 != DEFAULTVALUE){
     cloudPricingSheet.monthlyRecurring.SubTotalSaaS = '$' + value6.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",").replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    }else{
      cloudPricingSheet.monthlyRecurring.SubTotalSaaS = '';
    }

    var totalMiscellaneousArray = [];
    if(cloudPricingSheet.monthlyRecurring.SubTotalMiscellaneous != ''){
      totalMiscellaneousArray.push(parseFloat(cloudPricingSheet.monthlyRecurring.SubTotalMiscellaneous.slice(1).replace(/  |,/gi,"").replace(/  |,/gi,"")));
    }
    if(cloudPricingSheet.monthlyRecurring.SubTotalSaaS != ''){
      totalMiscellaneousArray.push(parseFloat(cloudPricingSheet.monthlyRecurring.SubTotalSaaS.slice(1).replace(/  |,/gi,"").replace(/  |,/gi,"")));
    }
    if(cloudPricingSheet.monthlyRecurring.SubtotalIaaS != ''){
      totalMiscellaneousArray.push(parseFloat(cloudPricingSheet.monthlyRecurring.SubtotalIaaS.slice(1).replace(/  |,/gi,"").replace(/  |,/gi,"")));
    }
    if(cloudPricingSheet.monthlyRecurring.oneTime != ''){
      totalMiscellaneousArray.push(parseFloat(cloudPricingSheet.monthlyRecurring.oneTime.slice(1).replace(/  |,/gi,"").replace(/  |,/gi,"")));
    }
    if(cloudPricingSheet.monthlyRecurring.AzureMonthly != ''){
      totalMiscellaneousArray.push(parseFloat(cloudPricingSheet.monthlyRecurring.AzureMonthly.slice(1).replace(/  |,/gi,"")));
    }
    var value7 = totalMiscellaneousArray.reduce(function (a, b) {
      return a + b;
    }, 0);
    if(value7 != DEFAULTVALUE){
      cloudPricingSheet.monthlyRecurring.TotalMonthlyRecurring = '$' + value7.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",").replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    }else{
      cloudPricingSheet.monthlyRecurring.TotalMonthlyRecurring = '';
    }
    let val = (parseFloat(cloudPricingSheet.monthlyRecurring.TotalMonthlyRecurring != '' ? cloudPricingSheet.monthlyRecurring.TotalMonthlyRecurring.slice(1).replace(/  |,/gi,"").replace(/  |,/gi,"") : '0'));
    let subVal = (parseFloat(cloudPricingSheet.monthlyRecurring.cloudMonthlyTotalDiscount != '' ? cloudPricingSheet.monthlyRecurring.cloudMonthlyTotalDiscount.slice(1).replace(/  |,/gi,"").replace(/  |,/gi,"") : '0'));
    let toatlVal = (val - subVal).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    if(toatlVal != '0.00'){
      cloudPricingSheet.FeesummaryMonthlyTotal = '$' + toatlVal.replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    }else{
      cloudPricingSheet.FeesummaryMonthlyTotal = '';
    }
    let objDta = {
      "oneTime" : 'One time',
      "monthly" : 'Monthly',
      "monthlyValue":  cloudPricingSheet.FeesummaryMonthlyTotal ,
      "OneTimeValue": cloudPricingSheet.TotalStartUp
    }
    this.dataService.broadcastInfo({ src: 'proposal-create', event: 'PAGE_HEADER_VALUE', params: objDta});
      localStorage.setItem('CLOUDScreenData', JSON.stringify(cloudPricingSheet));
    }
  }
  CyberScreenActivity() {
    if (localStorage.getItem('MSPForm')) {
      let mspFormValues = JSON.parse(localStorage.getItem('MSPForm'));
      var noOfUsers = mspFormValues.noOfUsers != '' ? mspFormValues.noOfUsers : DEFAULTVALUE.toString();
      var noOfDevices = mspFormValues.noOfDevices != '' ? mspFormValues.noOfDevices : DEFAULTVALUE.toString();
    }
    if (localStorage.getItem('CYBERScreenData')) {
      var cyberPricingSheet = JSON.parse(localStorage.getItem('CYBERScreenData'));
      let setupVal = (parseFloat(cyberPricingSheet.oneTimeFee.SetupConfigHours != '' ? cyberPricingSheet.oneTimeFee.SetupConfigHours : '0') * parseFloat(this.priceListTableService.priceList.TotalLabourRegularRate.slice(1).replace(/  |,/gi,"")));
      if(setupVal != DEFAULTVALUE){
        cyberPricingSheet.oneTimeFee.SetupConfigOneTime = '$' + setupVal.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      }else{
        cyberPricingSheet.oneTimeFee.SetupConfigOneTime = '';
      }
      let totalStartVal = (parseFloat(cyberPricingSheet.oneTimeFee.SetupConfigOneTime != '' ? cyberPricingSheet.oneTimeFee.SetupConfigOneTime.slice(1).replace(/  |,/gi,"") : '0') - parseFloat(cyberPricingSheet.oneTimeFee.CourtesyDiscountOneTime != '' ? cyberPricingSheet.oneTimeFee.CourtesyDiscountOneTime.slice(1).replace(/  |,/gi,"") : '0'));
      if(totalStartVal != DEFAULTVALUE){
        cyberPricingSheet.oneTimeFee.TotalStartUp = '$' + totalStartVal.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      }else{
        cyberPricingSheet.oneTimeFee.TotalStartUp = '';
      }
      cyberPricingSheet.cyberTools.forEach(elem => {
        this.priceListTableService.priceList.CyberTools.forEach(element => {
          if (elem.id == element.id && elem.incl == true) {
            let sumArray1 = [];
            elem.user = element.CdnMarkedUpSellingPrice.user != '$0.00' ? element.CdnMarkedUpSellingPrice.user : '';
            elem.device = element.CdnMarkedUpSellingPrice.device != '$0.00' ? element.CdnMarkedUpSellingPrice.device : '';
            elem.baseFree = element.CdnMarkedUpSellingPrice.basePrice != '$0.00' ? element.CdnMarkedUpSellingPrice.basePrice : '';
            elem.ttlUser = elem.user != '' ? '$' + (parseFloat(elem.user.slice(1).replace(/  |,/gi,"")) * parseInt(noOfUsers)).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") : '';
            if(element.id == 'CyberLearn'){
              elem.ttlUser = elem.user != '' ? '$' + (parseFloat(elem.user.slice(1).replace(/  |,/gi,"")) * parseInt(this.dataService.ProposalTable.mspForm.Mailboxes)).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") : '';
            }else{
              elem.ttlUser = elem.user != '' ? '$' + (parseFloat(elem.user.slice(1).replace(/  |,/gi,"")) * parseInt(this.dataService.ProposalTable.mspForm.noOfUsers)).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") : '';
            }
            elem.totalDevice = elem.device != '' ? '$' + (parseFloat(elem.device.slice(1).replace(/  |,/gi,"")) * parseInt(noOfDevices)).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") : '';
            var userVal = elem.ttlUser != '' ? parseFloat(elem.ttlUser.slice(1).replace(/  |,/gi,"")) : DEFAULTVALUE;
            var deviceVal = elem.totalDevice != '' ? parseFloat(elem.totalDevice.slice(1).replace(/  |,/gi,"")) : DEFAULTVALUE;
            var baseFreeVal = elem.baseFree != '' ? parseFloat(elem.baseFree.slice(1).replace(/  |,/gi,"")) : DEFAULTVALUE;
            sumArray1.push(userVal, deviceVal, baseFreeVal);
            var value = sumArray1.reduce(function (a, b) {
              return a + b;
            }, 0);
            if(value != DEFAULTVALUE){
              elem.subTotal = '$' + value.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
            }else{
              elem.subTotal = '';
            }
          }
        });
      });
      let userArray1 = [];
      let deviceArray1 = [];
      let baseFreeArray1 = [];
      let ttlUserArray1 = [];
      let totalDeviceArray1 = [];
      let subTotalArray1 = [];
      cyberPricingSheet.cyberTools.forEach(elem => {
        let userVal = elem.user != '' ? parseFloat(elem.user.slice(1).replace(/  |,/gi,"")) : DEFAULTVALUE;
        let deviceVal = elem.device != '' ? parseFloat(elem.device.slice(1).replace(/  |,/gi,"")) : DEFAULTVALUE;
        let baseFreeVal = elem.baseFree != '' ? parseFloat(elem.baseFree.slice(1).replace(/  |,/gi,"")) : DEFAULTVALUE;
        let ttlUserVal = elem.ttlUser != '' ? parseFloat(elem.ttlUser.slice(1).replace(/  |,/gi,"")) : DEFAULTVALUE;
        let totalDeviceVal = elem.totalDevice != '' ? parseFloat(elem.totalDevice.slice(1).replace(/  |,/gi,"")) : DEFAULTVALUE;
        let subTotalVal = elem.subTotal != '' ? parseFloat(elem.subTotal.slice(1).replace(/  |,/gi,"")) : DEFAULTVALUE;
        userArray1.push(userVal);
        deviceArray1.push(deviceVal);
        baseFreeArray1.push(baseFreeVal);
        ttlUserArray1.push(ttlUserVal);
        totalDeviceArray1.push(totalDeviceVal);
        subTotalArray1.push(subTotalVal);
      });
      cyberPricingSheet.subtotalCyberTools.subTotalUser = userArray1.reduce(function (a, b) { return a + b; }, 0).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") != '0.00' ? '$' + userArray1.reduce(function (a, b) { return a + b; }, 0).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") : '';
      cyberPricingSheet.subtotalCyberTools.subTotalDevice = deviceArray1.reduce(function (a, b) { return a + b; }, 0).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") != '0.00' ? '$' + deviceArray1.reduce(function (a, b) { return a + b; }, 0).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") : '';
      cyberPricingSheet.subtotalCyberTools.subTotalBaseFree = baseFreeArray1.reduce(function (a, b) { return a + b; }, 0).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") != '0.00' ? '$' + baseFreeArray1.reduce(function (a, b) { return a + b; }, 0).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") : '';
      cyberPricingSheet.subtotalCyberTools.subTotalTtlUser = ttlUserArray1.reduce(function (a, b) { return a + b; }, 0).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") != '0.00' ? '$' + ttlUserArray1.reduce(function (a, b) { return a + b; }, 0).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") : '';
      cyberPricingSheet.subtotalCyberTools.subTotalTtlDevice = totalDeviceArray1.reduce(function (a, b) { return a + b; }, 0).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") != '0.00' ? '$' + totalDeviceArray1.reduce(function (a, b) { return a + b; }, 0).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") : '';
      cyberPricingSheet.subtotalCyberTools.subTotalSubTotal = subTotalArray1.reduce(function (a, b) { return a + b; }, 0).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") != '0.00' ? '$' + subTotalArray1.reduce(function (a, b) { return a + b; }, 0).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") : '';
      cyberPricingSheet.additionalManagementTools.forEach(elem => {
        this.priceListTableService.priceList.AdditionalTools.forEach(element => {
          if (elem.id == element.id && elem.incl == true) {
            var sumArray = [];
            elem.user = element.CdnMarkedUpSellingPrice.user != '$0.00' ? element.CdnMarkedUpSellingPrice.user : '';
            elem.device = element.CdnMarkedUpSellingPrice.device != '$0.00' ? element.CdnMarkedUpSellingPrice.device : '';
            elem.baseFree = element.CdnMarkedUpSellingPrice.basePrice != '$0.00' ? element.CdnMarkedUpSellingPrice.basePrice : '';
            if(element.id == 'AvananAdvanced' || element.id == 'AvananBasic'){
              elem.ttlUser = elem.user != '' ? '$' + (parseFloat(elem.user.slice(1).replace(/  |,/gi,"")) * parseInt(this.dataService.ProposalTable.mspForm.Mailboxes)).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") : '';
            }else{
              elem.ttlUser = elem.user != '' ? '$' + (parseFloat(elem.user.slice(1).replace(/  |,/gi,"")) * parseInt(this.dataService.ProposalTable.mspForm.noOfUsers)).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") : '';
            }
            elem.totalDevice = elem.device != '' ? '$' + (parseFloat(elem.device.slice(1).replace(/  |,/gi,"")) * parseInt(noOfDevices)).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") : '';
            var userVal = elem.ttlUser != '' ? parseFloat(elem.ttlUser.slice(1).replace(/  |,/gi,"")) : DEFAULTVALUE;
            var deviceVal = elem.totalDevice != '' ? parseFloat(elem.totalDevice.slice(1).replace(/  |,/gi,"")) : DEFAULTVALUE;
            var baseFreeVal = elem.baseFree != '' ? parseFloat(elem.baseFree.slice(1).replace(/  |,/gi,"")) : DEFAULTVALUE;
            sumArray.push(userVal, deviceVal, baseFreeVal);
            var value1 = sumArray.reduce(function (a, b) {
              return a + b;
            }, 0);
            if(value1 != DEFAULTVALUE){
              elem.subTotal = '$' + value1.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
            }else{
              elem.subTotal = '';
            }
          }
        });
      });
      let userArray = [];
      let deviceArray = [];
      let baseFreeArray = [];
      let ttlUserArray = [];
      let totalDeviceArray = [];
      let subTotalArray = [];
      cyberPricingSheet.additionalManagementTools.forEach(elem => {
        let userVal = elem.user != '' ? parseFloat(elem.user.slice(1).replace(/  |,/gi,"")) : DEFAULTVALUE;
        let deviceVal = elem.device != '' ? parseFloat(elem.device.slice(1).replace(/  |,/gi,"")) : DEFAULTVALUE;
        let baseFreeVal = elem.baseFree != '' ? parseFloat(elem.baseFree.slice(1).replace(/  |,/gi,"")) : DEFAULTVALUE;
        let ttlUserVal = elem.ttlUser != '' ? parseFloat(elem.ttlUser.slice(1).replace(/  |,/gi,"")) : DEFAULTVALUE;
        let totalDeviceVal = elem.totalDevice != '' ? parseFloat(elem.totalDevice.slice(1).replace(/  |,/gi,"")) : DEFAULTVALUE;
        let subTotalVal = elem.subTotal != '' ? parseFloat(elem.subTotal.slice(1).replace(/  |,/gi,"")) : DEFAULTVALUE;
        userArray.push(userVal);
        deviceArray.push(deviceVal);
        baseFreeArray.push(baseFreeVal);
        ttlUserArray.push(ttlUserVal);
        totalDeviceArray.push(totalDeviceVal);
        subTotalArray.push(subTotalVal);
      });
      cyberPricingSheet.subtotalAdditionalManagementTools.subTotalUser = userArray.reduce(function (a, b) { return a + b; }, 0).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") != '0.00' ? '$' + userArray.reduce(function (a, b) { return a + b; }, 0).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") : '';
      cyberPricingSheet.subtotalAdditionalManagementTools.subTotalDevice = deviceArray.reduce(function (a, b) { return a + b; }, 0).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") != '0.00' ? '$' + deviceArray.reduce(function (a, b) { return a + b; }, 0).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") : '';
      cyberPricingSheet.subtotalAdditionalManagementTools.subTotalBaseFree = baseFreeArray.reduce(function (a, b) { return a + b; }, 0).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") != '0.00' ? '$' + baseFreeArray.reduce(function (a, b) { return a + b; }, 0).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") : '';
      cyberPricingSheet.subtotalAdditionalManagementTools.subTotalTtlUser = ttlUserArray.reduce(function (a, b) { return a + b; }, 0).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") != '0.00' ? '$' + ttlUserArray.reduce(function (a, b) { return a + b; }, 0).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") : '';
      cyberPricingSheet.subtotalAdditionalManagementTools.subTotalTtlDevice = totalDeviceArray.reduce(function (a, b) { return a + b; }, 0).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") != '0.00' ? '$' + totalDeviceArray.reduce(function (a, b) { return a + b; }, 0).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") : '';
      cyberPricingSheet.subtotalAdditionalManagementTools.subTotalSubTotal = subTotalArray.reduce(function (a, b) { return a + b; }, 0).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") != '0.00' ? '$' + subTotalArray.reduce(function (a, b) { return a + b; }, 0).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") : '';
      cyberPricingSheet.additionalUsers = '$' + (parseFloat(cyberPricingSheet.subtotalAdditionalManagementTools.subTotalUser != '' ? cyberPricingSheet.subtotalAdditionalManagementTools.subTotalUser.slice(1).replace(/  |,/gi,"") : DEFAULTVALUE.toString())
        + parseFloat(cyberPricingSheet.subtotalCyberTools.subTotalUser != '' ? cyberPricingSheet.subtotalCyberTools.subTotalUser.slice(1).replace(/  |,/gi,"") : DEFAULTVALUE.toString())).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      cyberPricingSheet.additionalDevices = '$' + (parseFloat(cyberPricingSheet.subtotalAdditionalManagementTools.subTotalDevice != '' ? cyberPricingSheet.subtotalAdditionalManagementTools.subTotalDevice.slice(1).replace(/  |,/gi,"") : DEFAULTVALUE.toString())
        + parseFloat(cyberPricingSheet.subtotalCyberTools.subTotalDevice != '' ? cyberPricingSheet.subtotalCyberTools.subTotalDevice.slice(1).replace(/  |,/gi,"") : DEFAULTVALUE.toString())).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      let val = (parseFloat(cyberPricingSheet.subtotalAdditionalManagementTools.subTotalSubTotal != '' ? cyberPricingSheet.subtotalAdditionalManagementTools.subTotalSubTotal.slice(1).replace(/  |,/gi,"") : '0')
        + parseFloat(cyberPricingSheet.subtotalCyberTools.subTotalSubTotal != '' ? cyberPricingSheet.subtotalCyberTools.subTotalSubTotal.slice(1).replace(/  |,/gi,"") : '0'));
      let ttlMonthlyVal =  (val - parseFloat(cyberPricingSheet.backupProdTotalDiscount != '' ? cyberPricingSheet.backupProdTotalDiscount.slice(1).replace(/  |,/gi,"") : DEFAULTVALUE.toString()));
        if(ttlMonthlyVal != DEFAULTVALUE){
          cyberPricingSheet.totalBackupDrMonthlyTool = '$' + ttlMonthlyVal.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        }else{
          cyberPricingSheet.totalBackupDrMonthlyTool = '';
        }
        let objDta = {
          "oneTime" : 'One time',
          "monthly" : 'Monthly',
          "monthlyValue": cyberPricingSheet.totalBackupDrMonthlyTool,
          "OneTimeValue": cyberPricingSheet.oneTimeFee.TotalStartUp
        }
        this.dataService.broadcastInfo({ src: 'proposal-create', event: 'PAGE_HEADER_VALUE', params: objDta});
      localStorage.setItem('CYBERScreenData', JSON.stringify(cyberPricingSheet));
    }
  }
  MspScreenActivity() {
    if (localStorage.getItem('MSPForm')) {
      let mspFormValues = JSON.parse(localStorage.getItem('MSPForm'));
      var noOfUsers = mspFormValues.noOfUsers != '' ? mspFormValues.noOfUsers : DEFAULTVALUE.toString();
      var noOfDevices = mspFormValues.noOfDevices != '' ? mspFormValues.noOfDevices : DEFAULTVALUE.toString();
    }
    if (localStorage.getItem('AllDatto') != null && localStorage.getItem('AllDatto') != "undefined") {
      var allDatto = localStorage.getItem('AllDatto');
      var AllDatto = JSON.parse(allDatto);
      AllDatto.forEach(element => {
        this.priceListTableService.priceList.Datto.DattoSize.forEach(elem => {
          if (element.device == elem.device) {
            element.monthlyPrice = elem.monthlyPrice;
            element.purchasePrice = elem.basePrice;
          }
        });
      });
    }
    if (localStorage.getItem('AllIntronis') != null && localStorage.getItem('AllIntronis') != "undefined") {
      var allIntronis = localStorage.getItem('AllIntronis');
      var AllIntronis = JSON.parse(allIntronis);
      AllIntronis.forEach(element => {
        this.priceListTableService.priceList.Intronis.forEach(elem => {
          if (element.device == elem.device) {
            element.monthlyPrice = elem.monthlyPrice;
          }
        });
      });
    }
    if (localStorage.getItem('SelectedDevices') != null && localStorage.getItem('SelectedDevices') != 'undefined') {
      var val = localStorage.getItem('SelectedDevices');
      let totalVal = JSON.parse(val);
      let sumArray = [];
      AllIntronis.forEach(elem => {
        if (elem.monthlyPrice == '') {
          var totalPrice = DEFAULTVALUE
        } else {
          totalPrice = parseFloat(elem.monthlyPrice.slice(1).replace(/  |,/gi,""));
        }
        sumArray.push(totalPrice)
      })
      var value = sumArray.reduce(function (a, b) {
        return a + b;
      }, 0);
      totalVal.intronisMonthlyPrice = '$' + value.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      let sumDattoArray = [];
      AllDatto.forEach(elem => {
        if (elem.monthlyPrice == '') {
          var totalPrice1 = DEFAULTVALUE
        } else {
          totalPrice1 = parseFloat(elem.monthlyPrice.slice(1).replace(/  |,/gi,""));
        }
        sumDattoArray.push(totalPrice1)
      })
      var value1 = sumDattoArray.reduce(function (a, b) {
        return a + b;
      }, 0);
      totalVal.dattoMonthlyPrice = '$' + value1.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      let sumDAttoOneTimeArray = [];
      AllDatto.forEach(elem => {
        if (elem.purchasePrice == '') {
          var totalOneTimePurchasePrice = DEFAULTVALUE
        } else {
          totalOneTimePurchasePrice = parseFloat(elem.purchasePrice.slice(1).replace(/  |,/gi,""));
        }
        sumDAttoOneTimeArray.push(totalOneTimePurchasePrice)
      })
      var value2 = sumDAttoOneTimeArray.reduce(function (a, b) {
        return a + b;
      }, 0);
      totalVal.dattoOneTime = '$' + value2.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      localStorage.setItem('SelectedDevices', JSON.stringify(totalVal));
    }
    if (localStorage.getItem('MSPScreenData')) {
      var mspPricingSheet = JSON.parse(localStorage.getItem('MSPScreenData'));
      if (mspPricingSheet.mspBackupDr.backupifyIncl == '1') {
        mspPricingSheet.mspBackupDr.backupifyMonthly = '$' + (parseFloat(this.priceListTableService.priceList.Backupify.Sell.slice(1).replace(/  |,/gi,"")) * parseInt(this.dataService.ProposalTable.mspForm.Mailboxes)).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      }
      let setupVal = (parseFloat(mspPricingSheet.mspStartupFees.SetupConfigHours != '' ? mspPricingSheet.mspStartupFees.SetupConfigHours : '0') * parseFloat(this.priceListTableService.priceList.TotalLabourRegularRate.slice(1).replace(/  |,/gi,"")))
      if(setupVal != DEFAULTVALUE){
        mspPricingSheet.mspStartupFees.SetupConfigOneTime = '$' + setupVal.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      }else{
        mspPricingSheet.mspStartupFees.SetupConfigOneTime = '';
      }
      let subTotlVal = (parseFloat(mspPricingSheet.mspStartupFees.SetupConfigOneTime != '' ? mspPricingSheet.mspStartupFees.SetupConfigOneTime.slice(1).replace(/  |,/gi,"") : '0') - parseFloat(mspPricingSheet.mspStartupFees.CourtesyDiscountHours != '' ? mspPricingSheet.mspStartupFees.CourtesyDiscountHours.slice(1).replace(/  |,/gi,"") : '0'));
      if(subTotlVal != DEFAULTVALUE){
        mspPricingSheet.mspStartupFees.subTotalStartUp = '$' + subTotlVal.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      }else{
        mspPricingSheet.mspStartupFees.subTotalStartUp = '';
      }
      if (localStorage.getItem('SelectedDevices') != "undefined"  && localStorage.getItem('SelectedDevices') != null) {
        var selectedDevice = localStorage.getItem('SelectedDevices');
        let SelectedDevices = JSON.parse(selectedDevice);
        mspPricingSheet.mspBackupDr.dattoOneTime = SelectedDevices.dattoOneTime;
        mspPricingSheet.mspBackupDr.dattoMonthly = SelectedDevices.dattoMonthlyPrice;
        mspPricingSheet.mspBackupDr.intronisMonthly = SelectedDevices.intronisMonthlyPrice;
      }
      this.priceListTableService.priceList.AdditionalTools.forEach(element => {
        var markupTool = 1 + parseInt(this.priceListTableService.priceList.TotalToolsMarkup != '' ? this.priceListTableService.priceList.TotalToolsMarkup.slice(0, -1) : '0') / 100;
        var permOrMarkup = 1 + parseFloat(element.permanentOrMarkup != '' ? element.permanentOrMarkup.slice(0, -1) : 0) / 100;
        var tempOrMarkup = 1 + parseFloat(element.temporaryOrMarkup != '' ? element.temporaryOrMarkup.slice(0, -1) : 0) / 100;
        if (element.temporaryOrMarkup != '') {
          if (element.id == 'Auvik') {
            element.CdnMarkedUpSellingPrice.basePrice = '$' + ((parseFloat(element.cdnCost.basePrice != '' ? element.cdnCost.basePrice.slice(1).replace(/  |,/gi,"") : '0') * tempOrMarkup) * this.dataService.ProposalTable.mspForm.noOfLocations).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
          } else {
            element.CdnMarkedUpSellingPrice.basePrice = '$' + (parseFloat(element.cdnCost.basePrice != '' ? element.cdnCost.basePrice.slice(1).replace(/  |,/gi,"") : '0') * tempOrMarkup).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
          }
          let device = (parseFloat(element.cdnCost.device != '' ? element.cdnCost.device.slice(1).replace(/  |,/gi,"") : '0') * tempOrMarkup).toFixed(3);
          element.CdnMarkedUpSellingPrice.user = '$' + (parseFloat(element.cdnCost.user != '' ? element.cdnCost.user.slice(1).replace(/  |,/gi,"") : '0') * tempOrMarkup).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
          element.CdnMarkedUpSellingPrice.device = '$' + parseFloat(device).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        } else if (element.permanentOrMarkup != '' && element.temporaryOrMarkup == '') {
          if (element.id == 'Auvik') {
            element.CdnMarkedUpSellingPrice.basePrice = '$' + ((parseFloat(element.cdnCost.basePrice != '' ? element.cdnCost.basePrice.slice(1).replace(/  |,/gi,"") : '0') * permOrMarkup) * this.dataService.ProposalTable.mspForm.noOfLocations).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
          } else {
            element.CdnMarkedUpSellingPrice.basePrice = '$' + (parseFloat(element.cdnCost.basePrice != '' ? element.cdnCost.basePrice.slice(1).replace(/  |,/gi,"") : '0') * permOrMarkup).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
          }
          let device = (parseFloat(element.cdnCost.device != '' ? element.cdnCost.device.slice(1).replace(/  |,/gi,"") : '0') * permOrMarkup).toFixed(3);
          element.CdnMarkedUpSellingPrice.user = '$' + (parseFloat(element.cdnCost.user != '' ? element.cdnCost.user.slice(1).replace(/  |,/gi,"") : '0') * permOrMarkup).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
          element.CdnMarkedUpSellingPrice.device = '$' + parseFloat(device).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        } else if (element.temporaryOrMarkup == '' && element.permanentOrMarkup == '') {
          if (element.id == 'Auvik') {
            element.CdnMarkedUpSellingPrice.basePrice = '$' + ((parseFloat(element.cdnCost.basePrice != '' ? element.cdnCost.basePrice.slice(1).replace(/  |,/gi,"") : '0') * markupTool) * this.dataService.ProposalTable.mspForm.noOfLocations).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
          } else {
            element.CdnMarkedUpSellingPrice.basePrice = '$' + (parseFloat(element.cdnCost.basePrice != '' ? element.cdnCost.basePrice.slice(1).replace(/  |,/gi,"") : '0') * markupTool).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
          }
          let device = (parseFloat(element.cdnCost.device != '' ? element.cdnCost.device.slice(1).replace(/  |,/gi,"") : '0') * markupTool).toFixed(3);
          element.CdnMarkedUpSellingPrice.user = '$' + (parseFloat(element.cdnCost.user != '' ? element.cdnCost.user.slice(1).replace(/  |,/gi,"") : '0') * markupTool).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
          element.CdnMarkedUpSellingPrice.device = '$' + parseFloat(device).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        }
      });
      mspPricingSheet.cyberTools.forEach(elem => {
        this.priceListTableService.priceList.CyberTools.forEach(element => {
          if (elem.id == element.id && elem.incl == true) {
            let sumArray1 = [];
            elem.user = element.CdnMarkedUpSellingPrice.user != '$0.00' ? element.CdnMarkedUpSellingPrice.user : '';
            elem.device = element.CdnMarkedUpSellingPrice.device != '$0.00' ? element.CdnMarkedUpSellingPrice.device : '';
            elem.baseFree = element.CdnMarkedUpSellingPrice.basePrice != '$0.00' ? element.CdnMarkedUpSellingPrice.basePrice : '';
            if(element.id == 'CyberLearn'){
              elem.ttlUser = elem.user != '' ? '$' + (parseFloat(elem.user.slice(1).replace(/  |,/gi,"")) * parseInt(this.dataService.ProposalTable.mspForm.Mailboxes)).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") : '';
            }else{
              elem.ttlUser = elem.user != '' ? '$' + (parseFloat(elem.user.slice(1).replace(/  |,/gi,"")) * parseInt(this.dataService.ProposalTable.mspForm.noOfUsers)).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") : '';
            }
            elem.totalDevice = elem.device != '' ? '$' + (parseFloat(elem.device.slice(1).replace(/  |,/gi,"")) * parseInt(noOfDevices)).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") : '';
            var userVal = elem.ttlUser != '' ? parseFloat(elem.ttlUser.slice(1).replace(/  |,/gi,"")) : DEFAULTVALUE;
            var deviceVal = elem.totalDevice != '' ? parseFloat(elem.totalDevice.slice(1).replace(/  |,/gi,"")) : DEFAULTVALUE;
            var baseFreeVal = elem.baseFree != '' ? parseFloat(elem.baseFree.slice(1).replace(/  |,/gi,"")) : DEFAULTVALUE;
            sumArray1.push(userVal, deviceVal, baseFreeVal);
            var value = sumArray1.reduce(function (a, b) {
              return a + b;
            }, 0);
            elem.subTotal = '$' + value.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
          }
        });
      });
      let userArray1 = [];
      let deviceArray1 = [];
      let baseFreeArray1 = [];
      let ttlUserArray1 = [];
      let totalDeviceArray1 = [];
      let subTotalArray1 = [];
      mspPricingSheet.cyberTools.forEach(elem => {
        let userVal = elem.user != '' ? parseFloat(elem.user.slice(1).replace(/  |,/gi,"")) : DEFAULTVALUE;
        let deviceVal = elem.device != '' ? parseFloat(elem.device.slice(1).replace(/  |,/gi,"")) : DEFAULTVALUE;
        let baseFreeVal = elem.baseFree != '' ? parseFloat(elem.baseFree.slice(1).replace(/  |,/gi,"")) : DEFAULTVALUE;
        let ttlUserVal = elem.ttlUser != '' ? parseFloat(elem.ttlUser.slice(1).replace(/  |,/gi,"")) : DEFAULTVALUE;
        let totalDeviceVal = elem.totalDevice != '' ? parseFloat(elem.totalDevice.slice(1).replace(/  |,/gi,"")) : DEFAULTVALUE;
        let subTotalVal = elem.subTotal != '' ? parseFloat(elem.subTotal.slice(1).replace(/  |,/gi,"")) : DEFAULTVALUE;
        userArray1.push(userVal);
        deviceArray1.push(deviceVal);
        baseFreeArray1.push(baseFreeVal);
        ttlUserArray1.push(ttlUserVal);
        totalDeviceArray1.push(totalDeviceVal);
        subTotalArray1.push(subTotalVal);
      });
      mspPricingSheet.subtotalCyberTools.subTotalUser = userArray1.reduce(function (a, b) { return a + b; }, 0).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") != '0.00' ? '$' + userArray1.reduce(function (a, b) { return a + b; }, 0).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") : '';
      mspPricingSheet.subtotalCyberTools.subTotalDevice = deviceArray1.reduce(function (a, b) { return a + b; }, 0).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") != '0.00' ? '$' + deviceArray1.reduce(function (a, b) { return a + b; }, 0).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") : '';
      mspPricingSheet.subtotalCyberTools.subTotalBaseFree = baseFreeArray1.reduce(function (a, b) { return a + b; }, 0).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") != '0.00' ? '$' + baseFreeArray1.reduce(function (a, b) { return a + b; }, 0).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") : '';
      mspPricingSheet.subtotalCyberTools.subTotalTtlUser = ttlUserArray1.reduce(function (a, b) { return a + b; }, 0).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") != '0.00' ? '$' + ttlUserArray1.reduce(function (a, b) { return a + b; }, 0).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") : '';
      mspPricingSheet.subtotalCyberTools.subTotalTtlDevice = totalDeviceArray1.reduce(function (a, b) { return a + b; }, 0).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") != '0.00' ? '$' + totalDeviceArray1.reduce(function (a, b) { return a + b; }, 0).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") : '';
      mspPricingSheet.subtotalCyberTools.subTotalSubTotal = subTotalArray1.reduce(function (a, b) { return a + b; }, 0).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") != '0.00' ? '$' + subTotalArray1.reduce(function (a, b) { return a + b; }, 0).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") : '';
      mspPricingSheet.additionalManagementTools.forEach(elem => {
        this.priceListTableService.priceList.AdditionalTools.forEach(element => {
          if (elem.id == element.id && elem.incl == true) {
            let sumArray = [];
            elem.user = element.CdnMarkedUpSellingPrice.user != '$0.00' ? element.CdnMarkedUpSellingPrice.user : '';
            elem.device = element.CdnMarkedUpSellingPrice.device != '$0.00' ? element.CdnMarkedUpSellingPrice.device : '';
            elem.baseFree = element.CdnMarkedUpSellingPrice.basePrice != '$0.00' ? element.CdnMarkedUpSellingPrice.basePrice : '';
            if(element.id == 'AvananAdvanced' || element.id == 'AvananBasic'){
              elem.ttlUser = elem.user != '' ? '$' + (parseFloat(elem.user.slice(1).replace(/  |,/gi,"")) * parseInt(this.dataService.ProposalTable.mspForm.Mailboxes)).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") : '';
            }else{
              elem.ttlUser = elem.user != '' ? '$' + (parseFloat(elem.user.slice(1).replace(/  |,/gi,"")) * parseInt(this.dataService.ProposalTable.mspForm.noOfUsers)).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") : '';
            }
            elem.totalDevice = elem.device != '' ? '$' + (parseFloat(elem.device.slice(1).replace(/  |,/gi,"")) * parseInt(noOfDevices)).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") : '';
            var userVal = elem.ttlUser != '' ? parseFloat(elem.ttlUser.slice(1).replace(/  |,/gi,"")) : DEFAULTVALUE;
            var deviceVal = elem.totalDevice != '' ? parseFloat(elem.totalDevice.slice(1).replace(/  |,/gi,"")) : DEFAULTVALUE;
            var baseFreeVal = elem.baseFree != '' ? parseFloat(elem.baseFree.slice(1).replace(/  |,/gi,"")) : DEFAULTVALUE;
            sumArray.push(userVal, deviceVal, baseFreeVal);
            var value = sumArray.reduce(function (a, b) {
              return a + b;
            }, 0);
            elem.subTotal = '$' + value.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
          }
        });
      });
      let userArray = [];
      let deviceArray = [];
      let baseFreeArray = [];
      let ttlUserArray = [];
      let totalDeviceArray = [];
      let subTotalArray = [];
      mspPricingSheet.additionalManagementTools.forEach(elem => {
        let userVal = elem.user != '' ? parseFloat(elem.user.slice(1).replace(/  |,/gi,"")) : DEFAULTVALUE;
        let deviceVal = elem.device != '' ? parseFloat(elem.device.slice(1).replace(/  |,/gi,"")) : DEFAULTVALUE;
        let baseFreeVal = elem.baseFree != '' ? parseFloat(elem.baseFree.slice(1).replace(/  |,/gi,"")) : DEFAULTVALUE;
        let ttlUserVal = elem.ttlUser != '' ? parseFloat(elem.ttlUser.slice(1).replace(/  |,/gi,"")) : DEFAULTVALUE;
        let totalDeviceVal = elem.totalDevice != '' ? parseFloat(elem.totalDevice.slice(1).replace(/  |,/gi,"")) : DEFAULTVALUE;
        let subTotalVal = elem.subTotal != '' ? parseFloat(elem.subTotal.slice(1).replace(/  |,/gi,"")) : DEFAULTVALUE;
        userArray.push(userVal);
        deviceArray.push(deviceVal);
        baseFreeArray.push(baseFreeVal);
        ttlUserArray.push(ttlUserVal);
        totalDeviceArray.push(totalDeviceVal);
        subTotalArray.push(subTotalVal);
      });
      mspPricingSheet.subtotalAdditionalManagementTools.subTotalUser = userArray.reduce(function (a, b) { return a + b; }, 0).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") != '0.00' ? '$' + userArray.reduce(function (a, b) { return a + b; }, 0).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") : '';
      mspPricingSheet.subtotalAdditionalManagementTools.subTotalDevice = deviceArray.reduce(function (a, b) { return a + b; }, 0).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") != '0.00' ? '$' + deviceArray.reduce(function (a, b) { return a + b; }, 0).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") : '';
      mspPricingSheet.subtotalAdditionalManagementTools.subTotalBaseFree = baseFreeArray.reduce(function (a, b) { return a + b; }, 0).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") != '0.00' ? '$' + baseFreeArray.reduce(function (a, b) { return a + b; }, 0).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") : '';
      mspPricingSheet.subtotalAdditionalManagementTools.subTotalTtlUser = ttlUserArray.reduce(function (a, b) { return a + b; }, 0).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") != '0.00' ? '$' + ttlUserArray.reduce(function (a, b) { return a + b; }, 0).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") : '';
      mspPricingSheet.subtotalAdditionalManagementTools.subTotalTtlDevice = totalDeviceArray.reduce(function (a, b) { return a + b; }, 0).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") != '0.00' ? '$' + totalDeviceArray.reduce(function (a, b) { return a + b; }, 0).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") : '';
      mspPricingSheet.subtotalAdditionalManagementTools.subTotalSubTotal = subTotalArray.reduce(function (a, b) { return a + b; }, 0).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") != '0.00' ? '$' + subTotalArray.reduce(function (a, b) { return a + b; }, 0).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") : '';
      let userArray2 = [];
      let deviceArray2 = [];
      let baseFreeArray2 = [];
      let ttlUserArray2 = [];
      let totalDeviceArray2 = [];
      let subTotalArray2 = [];
      mspPricingSheet.itManagementTools.forEach(elem => {
        this.priceListTableService.priceList.ItManagementTools.forEach(element => {
          if (elem.id == element.id && elem.incl == true) {
            let sumArray2 = [];
            elem.user = element.CdnMarkedUpSellingPrice.user != '$0.00' ? element.CdnMarkedUpSellingPrice.user : '';
            elem.device = element.CdnMarkedUpSellingPrice.device != '$0.00' ? element.CdnMarkedUpSellingPrice.device : '';
            elem.baseFree = element.CdnMarkedUpSellingPrice.basePrice != '$0.00' ? element.CdnMarkedUpSellingPrice.basePrice : '';
            elem.ttlUser = elem.user != '' ? '$' + (parseFloat(elem.user.slice(1).replace(/  |,/gi,"")) * parseInt(noOfUsers)).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") : '';
            elem.totalDevice = elem.device != '' ? '$' + (parseFloat(elem.device.slice(1).replace(/  |,/gi,"")) * parseInt(noOfDevices)).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") : '';
            var userVal = elem.ttlUser != '' ? parseFloat(elem.ttlUser.slice(1).replace(/  |,/gi,"")) : DEFAULTVALUE;
            var deviceVal = elem.totalDevice != '' ? parseFloat(elem.totalDevice.slice(1).replace(/  |,/gi,"")) : DEFAULTVALUE;
            var baseFreeVal = elem.baseFree != '' ? parseFloat(elem.baseFree.slice(1).replace(/  |,/gi,"")) : DEFAULTVALUE;
            sumArray2.push(userVal, deviceVal, baseFreeVal);
            var value = sumArray2.reduce(function (a, b) {
              return a + b;
            }, 0);
            elem.subTotal = '$' + value.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
          }
        });
      });
      mspPricingSheet.itManagementTools.forEach(elem => {
        let userVal = elem.user != '' ? parseFloat(elem.user.slice(1).replace(/  |,/gi,"")) : DEFAULTVALUE;
        let deviceVal = elem.device != '' ? parseFloat(elem.device.slice(1).replace(/  |,/gi,"")) : DEFAULTVALUE;
        let baseFreeVal = elem.baseFree != '' ? parseFloat(elem.baseFree.slice(1).replace(/  |,/gi,"")) : DEFAULTVALUE;
        let ttlUserVal = elem.ttlUser != '' ? parseFloat(elem.ttlUser.slice(1).replace(/  |,/gi,"")) : DEFAULTVALUE;
        let totalDeviceVal = elem.totalDevice != '' ? parseFloat(elem.totalDevice.slice(1).replace(/  |,/gi,"")) : DEFAULTVALUE;
        let subTotalVal = elem.subTotal != '' ? parseFloat(elem.subTotal.slice(1).replace(/  |,/gi,"")) : DEFAULTVALUE;
        userArray2.push(userVal);
        deviceArray2.push(deviceVal);
        baseFreeArray2.push(baseFreeVal);
        ttlUserArray2.push(ttlUserVal);
        totalDeviceArray2.push(totalDeviceVal);
        subTotalArray2.push(subTotalVal);
      });
      mspPricingSheet.subtotalItManagementTools.subTotalUser = userArray2.reduce(function (a, b) { return a + b; }, 0).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") != '0.00' ? '$' + userArray2.reduce(function (a, b) { return a + b; }, 0).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") : '';
      mspPricingSheet.subtotalItManagementTools.subTotalDevice = deviceArray2.reduce(function (a, b) { return a + b; }, 0).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") != '0.00' ? '$' + deviceArray2.reduce(function (a, b) { return a + b; }, 0).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") : '';
      mspPricingSheet.subtotalItManagementTools.subTotalBaseFree = baseFreeArray2.reduce(function (a, b) { return a + b; }, 0).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") != '0.00' ? '$' + baseFreeArray2.reduce(function (a, b) { return a + b; }, 0).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") : '';
      mspPricingSheet.subtotalItManagementTools.subTotalTtlUser = ttlUserArray2.reduce(function (a, b) { return a + b; }, 0).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") != '0.00' ? '$' + ttlUserArray2.reduce(function (a, b) { return a + b; }, 0).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") : '';
      mspPricingSheet.subtotalItManagementTools.subTotalTtlDevice = totalDeviceArray2.reduce(function (a, b) { return a + b; }, 0).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") != '0.00' ? '$' + totalDeviceArray2.reduce(function (a, b) { return a + b; }, 0).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") : '';
      mspPricingSheet.subtotalItManagementTools.subTotalSubTotal = subTotalArray2.reduce(function (a, b) { return a + b; }, 0).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") != '0.00' ? '$' + subTotalArray2.reduce(function (a, b) { return a + b; }, 0).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") : '';
      let sumArray3 = [];
      mspPricingSheet.backupTools.backupProdTable.forEach(elem => {
        if (elem.monthly == '') {
          var totalval = DEFAULTVALUE
        } else {
          totalval = parseFloat(elem.monthly.slice(1).replace(/  |,/gi,""));
        }
        sumArray3.push(totalval)
      })
      if (mspPricingSheet.mspBackupDr.dattoMonthly != '') {
        sumArray3.push(parseFloat(mspPricingSheet.mspBackupDr.dattoMonthly.slice(1).replace(/  |,/gi,"")));
      }
      if (mspPricingSheet.mspBackupDr.intronisMonthly != '') {
        sumArray3.push(parseFloat(mspPricingSheet.mspBackupDr.intronisMonthly.slice(1).replace(/  |,/gi,"")));
      }
      if (mspPricingSheet.mspBackupDr.backupifyMonthly != '') {
        sumArray3.push(parseFloat(mspPricingSheet.mspBackupDr.backupifyMonthly.slice(1).replace(/  |,/gi,"")));
      }
      var value = sumArray3.reduce(function (a, b) {
        return a + b;
      }, 0);
      if (value == DEFAULTVALUE) {
        mspPricingSheet.backupTools.totalBackupMonthlyPrice = '';
      } else {
        mspPricingSheet.backupTools.totalBackupMonthlyPrice = '$' + value.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      }
      mspPricingSheet.additionalUsers = '$' + (parseFloat(mspPricingSheet.subtotalItManagementTools.subTotalUser != '' ? mspPricingSheet.subtotalItManagementTools.subTotalUser.slice(1).replace(/  |,/gi,"") : DEFAULTVALUE.toString()) 
      + parseFloat(mspPricingSheet.subtotalAdditionalManagementTools.subTotalUser != '' ? mspPricingSheet.subtotalAdditionalManagementTools.subTotalUser.slice(1).replace(/  |,/gi,"") : DEFAULTVALUE.toString()) 
      + parseFloat(mspPricingSheet.subtotalCyberTools.subTotalUser != '' ? mspPricingSheet.subtotalCyberTools.subTotalUser.slice(1).replace(/  |,/gi,"") : DEFAULTVALUE.toString())).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      mspPricingSheet.additionalDevices = '$' + (parseFloat(mspPricingSheet.subtotalItManagementTools.subTotalDevice != '' ? mspPricingSheet.subtotalItManagementTools.subTotalDevice.slice(1).replace(/  |,/gi,"") : DEFAULTVALUE.toString()) 
      + parseFloat(mspPricingSheet.subtotalAdditionalManagementTools.subTotalDevice != '' ? mspPricingSheet.subtotalAdditionalManagementTools.subTotalDevice.slice(1).replace(/  |,/gi,"") : DEFAULTVALUE.toString()) 
      + parseFloat(mspPricingSheet.subtotalCyberTools.subTotalDevice != '' ? mspPricingSheet.subtotalCyberTools.subTotalDevice.slice(1).replace(/  |,/gi,"") : DEFAULTVALUE.toString())).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      let mspToolVal =  (parseFloat(mspPricingSheet.subtotalItManagementTools.subTotalSubTotal!= '' ? mspPricingSheet.subtotalItManagementTools.subTotalSubTotal.slice(1).replace(/  |,/gi,"") : '0')
      + parseFloat(mspPricingSheet.subtotalAdditionalManagementTools.subTotalSubTotal != '' ? mspPricingSheet.subtotalAdditionalManagementTools.subTotalSubTotal.slice(1).replace(/  |,/gi,"") : '0')
      + parseFloat(mspPricingSheet.subtotalCyberTools.subTotalSubTotal != '' ? mspPricingSheet.subtotalCyberTools.subTotalSubTotal.slice(1).replace(/  |,/gi,"") : '0')
      + parseFloat(mspPricingSheet.mspBackupDr.TotalBackupDrOneTime != '' ? mspPricingSheet.mspBackupDr.TotalBackupDrOneTime.slice(1).replace(/  |,/gi,"") : '0'))
      if(mspToolVal != DEFAULTVALUE){
        mspPricingSheet.TotalMspToolSets = '$' + mspToolVal.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      }else{
        mspPricingSheet.TotalMspToolSets = '';
      }
      let val = (parseFloat(mspPricingSheet.mspMonthlyServices.TotalOneTimeEffort != '' ? mspPricingSheet.mspMonthlyServices.TotalOneTimeEffort.slice(1).replace(/  |,/gi,"") : '0')
      + parseFloat(mspPricingSheet.mspMonthlyServices.subTotalMonthlyOneTime != '' ? mspPricingSheet.mspMonthlyServices.subTotalMonthlyOneTime.slice(1).replace(/  |,/gi,"") : '0') +
      parseFloat(mspPricingSheet.subtotalItManagementTools.subTotalSubTotal != '' ? mspPricingSheet.subtotalItManagementTools.subTotalSubTotal.slice(1).replace(/  |,/gi,"") : '0')
      + parseFloat(mspPricingSheet.subtotalAdditionalManagementTools.subTotalSubTotal != '' ? mspPricingSheet.subtotalAdditionalManagementTools.subTotalSubTotal.slice(1).replace(/  |,/gi,"") : '0')
      + parseFloat(mspPricingSheet.subtotalCyberTools.subTotalSubTotal != '' ? mspPricingSheet.subtotalCyberTools.subTotalSubTotal.slice(1).replace(/  |,/gi,"") : '0')
      + parseFloat(mspPricingSheet.backupTools.totalBackupMonthlyPrice != '' ? mspPricingSheet.backupTools.totalBackupMonthlyPrice.slice(1).replace(/  |,/gi,"") : '0'));
    let subVal = (parseFloat(mspPricingSheet.backupTools.backupProdTotalDiscount != '' ? mspPricingSheet.backupTools.backupProdTotalDiscount.slice(1).replace(/  |,/gi,"") : '0'));
    let toatlVal = (val - subVal).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    if (toatlVal == '0.00') {
     mspPricingSheet.mspFeesummaryTotal = '';
    } else {
      mspPricingSheet.mspFeesummaryTotal = '$' + toatlVal;
    }
    if (mspPricingSheet.miscProductService.subTotalMiscOneTime != undefined && mspPricingSheet.miscProductService.subTotalMiscOneTime != '') {
  var subtTotal1 = parseFloat(mspPricingSheet.miscProductService.subTotalMiscOneTime.slice(1).replace(/  |,/gi,""));
} else {
  subtTotal1 = DEFAULTVALUE;
}
if (mspPricingSheet.mspStartupFees.subTotalStartUp != '') {
  var subtTotal2 = parseFloat(mspPricingSheet.mspStartupFees.subTotalStartUp.slice(1).replace(/  |,/gi,""));
} else {
  subtTotal2 = DEFAULTVALUE;
}
if (mspPricingSheet.mspBackupDr.TotalBackupDrOneTime != '') {
  var subtTotal3 = parseFloat(mspPricingSheet.mspBackupDr.TotalBackupDrOneTime.slice(1).replace(/  |,/gi,""));
} else {
  subtTotal3 = DEFAULTVALUE;
}
let Total = (subtTotal1 + subtTotal2 + subtTotal3).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
if (Total == '0.00') {
  mspPricingSheet.miscProductService.totalManagedServiceOneTimeFees = '';
} else {
  mspPricingSheet.miscProductService.totalManagedServiceOneTimeFees = '$' + Total;
}
let objDta = {
  "oneTime" : 'One time',
  "monthly" : 'Monthly',
  "monthlyValue":  mspPricingSheet.mspFeesummaryTotal,
  "OneTimeValue": mspPricingSheet.miscProductService.totalManagedServiceOneTimeFee
}
this.dataService.broadcastInfo({ src: 'proposal-create', event: 'PAGE_HEADER_VALUE', params: objDta});
      localStorage.setItem('MSPScreenData', JSON.stringify(mspPricingSheet));
    }
    localStorage.setItem('AllIntronis', JSON.stringify(AllIntronis));
    localStorage.setItem('AllDatto', JSON.stringify(AllDatto));
  }
  BackupDrScreenActivity() {
    if (localStorage.getItem('BackupDrAllDatto') != null && localStorage.getItem('BackupDrAllDatto') != 'undefined') {
      var allDatto = localStorage.getItem('BackupDrAllDatto');
      var AllDatto = JSON.parse(allDatto);
      AllDatto.forEach(element => {
        this.priceListTableService.priceList.Datto.DattoSize.forEach(elem => {
          if (element.device == elem.device) {
            element.monthlyPrice = elem.monthlyPrice;
            element.purchasePrice = elem.basePrice;
          }
        });
      });
    }
    if (localStorage.getItem('BackupDrAllIntronis') != null && localStorage.getItem('BackupDrAllIntronis') != 'undefined') {
      var allIntronis = localStorage.getItem('BackupDrAllIntronis');
      var AllIntronis = JSON.parse(allIntronis);
      AllIntronis.forEach(element => {
        this.priceListTableService.priceList.Intronis.forEach(elem => {
          if (element.device == elem.device) {
            element.monthlyPrice = elem.monthlyPrice;
          }
        });
      });
    }
    if (localStorage.getItem('BackupDrSelectedDevices') != null && localStorage.getItem('BackupDrSelectedDevices') != 'undefined') {
      var val = localStorage.getItem('BackupDrSelectedDevices');
      let totalVal = JSON.parse(val);
      let sumArray = [];
      AllIntronis.forEach(elem => {
        if (elem.monthlyPrice == '') {
          var totalPrice = DEFAULTVALUE
        } else {
          totalPrice = parseFloat(elem.monthlyPrice.slice(1).replace(/  |,/gi,""));
        }
        sumArray.push(totalPrice)
      })
      var value = sumArray.reduce(function (a, b) {
        return a + b;
      }, 0);
      totalVal.intronisMonthlyPrice = '$' + value.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      let sumDattoArray = [];
      AllDatto.forEach(elem => {
        if (elem.monthlyPrice == '') {
          var totalPrice1 = DEFAULTVALUE
        } else {
          totalPrice1 = parseFloat(elem.monthlyPrice.slice(1).replace(/  |,/gi,""));
        }
        sumDattoArray.push(totalPrice1)
      })
      var value1 = sumDattoArray.reduce(function (a, b) {
        return a + b;
      }, 0);
      totalVal.dattoMonthlyPrice = '$' + value1.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      let sumDAttoOneTimeArray = [];
      AllDatto.forEach(elem => {
        if (elem.purchasePrice == '') {
          var totalOneTimePurchasePrice = DEFAULTVALUE
        } else {
          totalOneTimePurchasePrice = parseFloat(elem.purchasePrice.slice(1).replace(/  |,/gi,""));
        }
        sumDAttoOneTimeArray.push(totalOneTimePurchasePrice)
      })
      var value2 = sumDAttoOneTimeArray.reduce(function (a, b) {
        return a + b;
      }, 0);
      totalVal.dattoOneTime = '$' + value2.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      localStorage.setItem('BackupDrSelectedDevices', JSON.stringify(totalVal));
    }
    if (localStorage.getItem('BACKUPDRsScreenData')) {
      let backupDrPricingSheet = JSON.parse(localStorage.getItem('BACKUPDRsScreenData'));
      if (localStorage.getItem('BackupDrSelectedDevices') != null && localStorage.getItem('BackupDrSelectedDevices') != 'undefined') {
        var selectedDevice = localStorage.getItem('BackupDrSelectedDevices');
        let SelectedDevices = JSON.parse(selectedDevice);
        backupDrPricingSheet.mspBackupDr.dattoOneTime = SelectedDevices.dattoOneTime;
        backupDrPricingSheet.mspBackupDr.dattoMonthly = SelectedDevices.dattoMonthlyPrice;
        backupDrPricingSheet.mspBackupDr.intronisMonthly = SelectedDevices.intronisMonthlyPrice;
      }
      if(backupDrPricingSheet.mspBackupDr.backupifyIncl ==  '1'){
        backupDrPricingSheet.mspBackupDr.backupifyMonthly = '$' + (parseFloat(this.priceListTableService.priceList.Backupify.Sell.slice(1).replace(/  |,/gi,"")) * parseInt(this.dataService.ProposalTable.mspForm.Mailboxes)).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      }
      let setupVal = (parseFloat(backupDrPricingSheet.oneTimeFee.SetupConfigHours != '' ? backupDrPricingSheet.oneTimeFee.SetupConfigHours : '0') * parseFloat(this.priceListTableService.priceList.TotalLabourRegularRate.slice(1).replace(/  |,/gi,"")))
        if(setupVal != DEFAULTVALUE){
          backupDrPricingSheet.oneTimeFee.SetupConfigOneTime = '$' + setupVal.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        }else{
          backupDrPricingSheet.oneTimeFee.SetupConfigOneTime = '';
        }
        let subTotlVal = (parseFloat(backupDrPricingSheet.oneTimeFee.SetupConfigOneTime != '' ? backupDrPricingSheet.oneTimeFee.SetupConfigOneTime.slice(1).replace(/  |,/gi,"") : '0') - parseFloat(backupDrPricingSheet.oneTimeFee.CourtesyDiscountOneTime != '' ? backupDrPricingSheet.oneTimeFee.CourtesyDiscountOneTime.slice(1).replace(/  |,/gi,"") : '0'));
        if(subTotlVal != DEFAULTVALUE){
          backupDrPricingSheet.oneTimeFee.subTotalStartUp = '$' + subTotlVal.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        }else{
          backupDrPricingSheet.oneTimeFee.subTotalStartUp = '';
        }
      if (backupDrPricingSheet.oneTimeFee.subTotalStartUp != undefined && backupDrPricingSheet.oneTimeFee.subTotalStartUp != '') {
        var subtTotal1 = parseFloat(backupDrPricingSheet.oneTimeFee.subTotalStartUp.slice(1).replace(/  |,/gi,""));
      } else {
        subtTotal1 = DEFAULTVALUE;
      }
      if (backupDrPricingSheet.mspBackupDr.TotalBackupDrOneTime != '') {
        var subtTotal2 = parseFloat(backupDrPricingSheet.mspBackupDr.TotalBackupDrOneTime.slice(1).replace(/  |,/gi,""));
      } else {
        subtTotal2 = DEFAULTVALUE;
      }
      let Total = (subtTotal1 + subtTotal2).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      if (Total == '0.00') {
        backupDrPricingSheet.totalBackupDrServiceOneTimeFees = '';
      } else {
        backupDrPricingSheet.totalBackupDrServiceOneTimeFees = '$' + Total;
      }
      let value = ((parseFloat(backupDrPricingSheet.backupTools.totalBackupMonthlyPrice != '' ? backupDrPricingSheet.backupTools.totalBackupMonthlyPrice.slice(1).replace(/  |,/gi,"") : '0')
      + parseFloat(backupDrPricingSheet.mspBackupDr.backupifyMonthly != '' ? backupDrPricingSheet.mspBackupDr.backupifyMonthly.slice(1).replace(/  |,/gi,"") : '0')
      + parseFloat(backupDrPricingSheet.mspBackupDr.intronisMonthly != '' ? backupDrPricingSheet.mspBackupDr.intronisMonthly.slice(1).replace(/  |,/gi,"") : '0')
      + parseFloat(backupDrPricingSheet.mspBackupDr.dattoMonthly != '' ? backupDrPricingSheet.mspBackupDr.dattoMonthly.slice(1).replace(/  |,/gi,"") : '0')))
      if(value != DEFAULTVALUE){
        backupDrPricingSheet.backupTools.totalBackupDrMonthlyTool = '$' + value.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      }else{
        backupDrPricingSheet.backupTools.totalBackupDrMonthlyTool = '';
      }
      let val = (parseFloat(backupDrPricingSheet.backupTools.totalBackupDrMonthlyTool != '' ? backupDrPricingSheet.backupTools.totalBackupDrMonthlyTool.slice(1).replace(/  |,/gi,"") : '0'));
      let subVal = (parseFloat(backupDrPricingSheet.backupTools.backupProdTotalDiscount != '' ? backupDrPricingSheet.backupTools.backupProdTotalDiscount.slice(1).replace(/  |,/gi,"") : '0'));
      let toatlVal = (val - subVal);
      if(toatlVal != DEFAULTVALUE){
       backupDrPricingSheet.BackupFeesummaryTotaly = '$' + toatlVal.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      }else{
       backupDrPricingSheet.BackupFeesummaryTotaly = '';
      }
      let objDta = {
        "oneTime" : 'One time',
        "monthly" : 'Monthly',
        "monthlyValue": backupDrPricingSheet.BackupFeesummaryTotaly,
        "OneTimeValue": backupDrPricingSheet.totalBackupDrServiceOneTimeFees
      }
      this.dataService.broadcastInfo({ src: 'proposal-create', event: 'PAGE_HEADER_VALUE', params: objDta});
      localStorage.setItem('BACKUPDRsScreenData', JSON.stringify(backupDrPricingSheet));
    }
    localStorage.setItem('BackupDrAllIntronis', JSON.stringify(AllIntronis));
    localStorage.setItem('BackupDrAllDatto', JSON.stringify(AllDatto));
  }
  ProjectActivity() {
    var projectScreenData = JSON.parse(localStorage.getItem('ProjectScreen'));
    if (projectScreenData != null) {
      projectScreenData.projectService.Hourly.forEach(element => {
        if(element.hours != ''){
          let totalVal = parseFloat(element.hours) * parseFloat(this.priceListTableService.priceList.TotalLabourRegularRate.slice(1).replace(/  |,/gi,""));
          element.total = '$' + totalVal.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        }
      });
      let ProjectArray = [];
      projectScreenData.projectService.FlatFree.forEach(elem => {
        if (elem.total == '') {
          var flat_fee = DEFAULTVALUE
        } else {
          flat_fee = parseFloat(elem.total.slice(1).replace(/  |,/gi,""));
        }
        ProjectArray.push(flat_fee)
      })
      projectScreenData.projectService.Hourly.forEach(elem => {
        if (elem.total == '') {
          var total = DEFAULTVALUE
        } else {
          total = parseFloat(elem.total.slice(1).replace(/  |,/gi,""));
        }
        ProjectArray.push(total)
      })
      var totalVal = ProjectArray.reduce(function (a, b) {
        return a + b;
      }, 0);
      var value = totalVal - parseFloat(projectScreenData.projectService.courtesyDiscount != '' ? projectScreenData.projectService.courtesyDiscount.slice(1).replace(/  |,/gi,"") : DEFAULTVALUE);
      if (value != 0) {
        projectScreenData.projectService.TotalProjectService = '$' + (Math.round((value + Number.EPSILON) * 100) / 100).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      } else {
        projectScreenData.projectService.TotalProjectService = '';
      }
      let objDta = {
        "oneTime" : 'One time Service',
        "monthly" : 'Product',
        "monthlyValue": projectScreenData.Hslw.totalHslw,
        "OneTimeValue": projectScreenData.projectService.TotalProjectService
      }
      this.dataService.broadcastInfo({ src: 'proposal-create', event: 'PAGE_HEADER_VALUE', params: objDta});
      localStorage.setItem('ProjectScreen', JSON.stringify(projectScreenData));
    }
  }
  @HostListener('document:click', ['$event.target'])
  public onClick(targetElement) {
    const objLen = 0;
    if (targetElement.classList[objLen] != 'button-inner') {
      this.showList = false;
    }
  };
  mergeHtml() {
    let myModal = this.modalCtrl.create(ModalPopupPage, { 'name': 'Merge' });
    myModal.onDidDismiss(data => {
    })
    myModal.present();
  }
  insertHtml() {
    let myModal = this.modalCtrl.create(ModalPopupPage, { 'name': 'Insert' });
    myModal.onDidDismiss(data => {
    })
    myModal.present();
  }
  deleteHtml() {
    let myModal = this.modalCtrl.create(ModalPopupPage, { 'name': 'Delete' });
    myModal.onDidDismiss(data => {
    })
    myModal.present();
  }
  mergePage() {
    this.dataService.broadcastInfo({ src: 'proposal-pdf', event: 'GENERATE_PDF', status: true});
  }
  openSideBar() {
    this.showSideBar = !this.showSideBar;
    this.dataService.broadcastInfo({ src: 'show-sidebar', event: 'SIDEBAR', status: this.showSideBar});
  }
  pageClass(event) {
    this.pageClassName = event;
    const componentFactory = this.resolver.resolveComponentFactory(this.pageClassName['component']);
    this.viewContainerRef.clear();
    this.componentRef = this.viewContainerRef.createComponent(componentFactory);
    this.componentRef.instance.params = event;

  }
  onMerge() {
    let templateProperty: any;
    templateProperty = this.componentService.tabTemplates[0];
    templateProperty.templates.forEach(element => {
      if (element.selectIcon == false) {
        if (this.selTemplates.includes(element.templateName) == false) {
          this.selTemplates.push(element.templateName);
        }
      }
    });
    // this.events.publish("previewMergePages", this.selTemplates);
    this.selTemplates = [];
  }

  loadMaster(){
    if(this.dataService.ScreenName == 'MSA'){
      let myModal = this.modalCtrl.create(ModalPopupPage, { 'name': 'MSA_MASTER' });
      myModal.onDidDismiss(data => {
      })
      myModal.present();
    }else if(this.dataService.ScreenName == 'SOW'){
      let myModal = this.modalCtrl.create(ModalPopupPage, { 'name': 'SOW_MASTER' });
      myModal.onDidDismiss(data => {
      })
      myModal.present();
    }else if(this.dataService.ScreenName == 'PRICELIST'){
      let myModal = this.modalCtrl.create(ModalPopupPage, { 'name': 'PRICELIST_MASTER' });
      myModal.onDidDismiss(data => {
      })
      myModal.present();
    }
  }

  saveMaster(){
    this.dataService.broadcastInfo({ src: 'proposal-create', event: 'PAGE_HEADER_VALUE', params: ''});
    if(this.dataService.ScreenName == 'MSA'){
      this.dataService.broadcastInfo({ src: 'proposal-view', event: 'EDIT_MSA_MASTER', status: true});
    }else if(this.dataService.ScreenName == 'SOW'){
      this.dataService.broadcastInfo({ src: 'proposal-view', event: 'EDIT_SOW_MASTER', status: true});
    }else if(this.dataService.ScreenName == 'SOW-LIST'){
      this.dataService.broadcastInfo({ src: 'proposal-view', event: 'EDIT_SOW_LIST_MASTER', status: true});
    }else if(this.dataService.ScreenName == 'PRICELIST'){
      let alert = this.alertCtrl.create({
        title: 'Pricelist Version',
        enableBackdropDismiss: false,
        inputs: [
          {
            name: 'VersionName',
            placeholder: 'Version Name',
            value: this.priceListTableService.pricelistVersionName
          }
        ],
        buttons: [
          {
            text: 'OK',
            handler: data => {
              if (data["VersionName"].trim() == "") {
                const toast = this.toastController.create({
                  message: 'Name Cannot be Empty!',
                  duration: 5000,
                });
                toast.present();
                this.saveMaster();
              }else{
                let foldername: any = this.configApiService.pricelistMaster.find(item => item.versions == data.VersionName);
                if (foldername && this.priceListTableService.pricelistID == '') {
                  const toast = this.toastController.create({
                    message: 'Version Name already exists.',
                    duration: 2000
                  });
                  toast.present();
                  this.saveMaster();
                } else {
                  var currentDate: any = new Date();
                  let currentMonth: any= currentDate.getMonth() + 1;
                  let date = currentDate.getFullYear()+ '-'+ currentMonth.toString().padStart(2, '0')+'-'+currentDate.getDate().toString().padStart(2, '0');
                  let obj = {
                    "Pricelist_Master_1_Id": this.priceListTableService.pricelistID,
                    "status":"",
                    "Tag":"",
                    "Created_By":"",
                    "Modified_By":"",
                    "Modified_date":"",
                    "currentDate": date,
                    "jsonData": this.priceListTableService.PricelistJson,
                    "versions": data["VersionName"],
                    "Created_date":"",
                    "userid":3280,
                    "rptname":"Pricelist_Master_12148",
                    "client":"starport1294"
                    }
                  let objData = { data: JSON.stringify(obj) }
                  this.configApiService.saveContract(objData).subscribe(respdata => {
                    if (respdata["_POST_AddMethodResult"].length > 0) {
                      if (respdata["_POST_AddMethodResult"][0].Result !== "FAIL") {
                        let resp = JSON.parse(respdata["_POST_AddMethodResult"][0].Ref_ID);
                        this.priceListTableService.pricelistID = resp.Pricelist_Master_1_Id;
                        localStorage.setItem('Pricelist', JSON.stringify(this.priceListTableService.PricelistJson));
                        this.reCalculation();
                        this.configApiService.getPriceListMaster();
                      }
                    }
                  });
                }
              }
            }
          }
        ]
      });
      alert.present();
    }
  }
  addNewPricelist(){
    this.configApiService.pricelistMaster.forEach(element => {
      if(element.versions == 'New-Pricelist'){
        this.priceListTableService.newPricelist = JSON.parse(element.jsonData);
        this.dataService.broadcastInfo({ src: 'proposal-create', event: 'PAGE_HEADER_VALUE', params: ''});
        this.priceListTableService.pricelistID = '';
        this.priceListTableService.pricelistVersionName = '';
      }
    });
  }
  ngAfterContentChecked() {
    this.cdr.detectChanges();
  }
  ngOnDestroy() {
    this.events.unsubscribe('SelectedPage');
    this.broadcastSubs.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/components/component-holder/component-holder.ts